import axios from "axios";
import store from "../../store";
import ASO, { withTsecAuth, getFlowIdByCamp } from "../../api/aso";
import Vue from "vue";
import { DO_DATA_AUTH_ASO } from "@/config/constants/action-types";

jest.mock("axios");
jest.mock("../../store");

Vue.$log = {
  debug: jest.fn(),
  error: jest.fn()
};

describe("ASO API", () => {
  describe("obtenerTsec", () => {
    it("should obtain tsec token", async () => {
      const tsec = "mocked-tsec-token";
      axios.post.mockResolvedValue({ headers: { tsec } });

      const payload = {
        authentication: {
          userID: "ZG16027",
          consumerID: "16000027",
          authenticationType: "61",
          authenticationData: []
        },
        backendUserRequest: {
          userId: "",
          accessCode: "16000027",
          dialogId: ""
        }
      };
      const result = await ASO.obtenerTsec(payload);

      expect(axios.post).toHaveBeenCalledWith(
        expect.stringContaining("/TechArchitecture/mx/grantingTicket/V02"),
        expect.objectContaining(payload),
        expect.objectContaining({ withCredentials: true })
      );
      expect(result.headers.tsec).toBe(tsec);
    });

    it("should handle error", async () => {
      const error = new Error("Network Error");
      axios.post.mockRejectedValue(error);

      const payload = { some: "data" };
      await expect(ASO.obtenerTsec(payload)).rejects.toThrow(error);
    });
  });

  describe("getVeridasIframe", () => {
    it("should get Veridas iframe data", async () => {
      const iframeData = { url: "https://example.com" };
      axios.post.mockResolvedValue({ data: iframeData });

      const payload = { some: "data" };
      const config = { headers: { tsec: "mocked-tsec-token" } };
      const result = await ASO.getVeridasIframe(payload, config);

      expect(axios.post).toHaveBeenCalledWith(
        expect.stringContaining("/documents-verifications/v3/validations"),
        expect.any(Object),
        config
      );
      expect(result.data).toBe(iframeData);
    });

    it("should handle error", async () => {
      const error = new Error("Network Error");
      axios.post.mockRejectedValue(error);

      const payload = { some: "data" };
      const config = { headers: { tsec: "mocked-tsec-token" } };
      await expect(ASO.getVeridasIframe(payload, config)).rejects.toThrow(
        error
      );
    });
  });

  describe("withTsecAuth", () => {
    jest.spyOn(ASO, "obtenerTsec");

    beforeEach(() => {
      jest.clearAllMocks();
    });

    afterEach(() => {
      jest.clearAllMocks();
    });

    it("should use existing tsec token if not expired", async () => {
      const currentTime = new Date().getTime();
      const existingTsec = {
        tsec: "existing-tsec",
        tsecExpiry: currentTime + 1000
      };

      store.getters = {
        getDataAuthASO: jest.fn(() => existingTsec)
      };

      const tsec = "mocked-tsec-token";
      const iframeData = { url: "https://example.com" };
      axios.post.mockResolvedValueOnce({ headers: { tsec } });
      axios.post.mockResolvedValueOnce({ data: iframeData });
      const apiCallFunc = jest.fn().mockResolvedValue({ data: iframeData });
      const payload = { some: "data" };

      const result = await withTsecAuth(apiCallFunc, payload);

      expect(apiCallFunc).toHaveBeenCalledWith(payload, {
        headers: { tsec: existingTsec.tsec }
      });
      expect(result.data).toBe(iframeData);
      expect(ASO.obtenerTsec).not.toHaveBeenCalled();
    });

    it("should get new tsec token if expired", async () => {
      const currentTime = new Date().getTime();

      const tsec = "mocked-tsec-token";
      let obtenerTsecResponse = {
        data: {
          authenticationResponse: {
            authenticationState: "OK"
          }
        },
        headers: { tsec }
      };
      const iframeData = { url: "https://example.com" };
      axios.post.mockResolvedValueOnce(obtenerTsecResponse);
      axios.post.mockResolvedValueOnce({ data: iframeData });

      store.getters = {
        getDataAuthASO: jest.fn(() => ({
          tsec: "expired-tsec",
          tsecExpiry: currentTime - 1000 // expired
        }))
      };

      const newTsec = "new-tsec";
      obtenerTsecResponse.headers.tsec = newTsec;
      ASO.obtenerTsec.mockResolvedValue(obtenerTsecResponse);
      const apiCallFunc = jest.fn().mockResolvedValue({ data: "success" });
      const payload = { some: "data" };

      await withTsecAuth(apiCallFunc, payload);

      expect(store.dispatch).toHaveBeenCalledWith(DO_DATA_AUTH_ASO, {
        tsec: newTsec,
        tsecExpiry: expect.any(Number)
      });
      expect(apiCallFunc).toHaveBeenCalledWith(payload, {
        headers: { tsec: newTsec }
      });
    });
  });

  describe("Get Verification Result ASO", () => {
    it("debería realizar un GET exitoso para obtener los resultados de Veridas", async () => {
      const config = { headers: { tsec: "mocked-tsec" } };
      const veridasId = "mocked-veridas-id";

      const mockedResponse = { data: { result: "success" } };
      axios.get.mockResolvedValue(mockedResponse);

      const response = await ASO.getVeridasResult(veridasId, config);

      expect(axios.get).toHaveBeenCalledWith(
        `https://aso-int-ar.work-02.platform.bbva.com/documents-verifications/v3/validations/${veridasId}?flowId=00018`,
        config
      );

      expect(response).toEqual(mockedResponse);
    });

    it("debería manejar errores al realizar el GET", async () => {
      const config = { headers: { tsec: "mocked-tsec" } };
      const veridasId = "mocked-veridas-id";

      const mockedError = new Error("Error en la solicitud");
      axios.get.mockRejectedValue(mockedError);

      await expect(ASO.getVeridasResult(veridasId, config)).rejects.toThrow(
        "Error en la solicitud"
      );

      // Verificar que Axios fue llamado con los parámetros correctos
      expect(axios.get).toHaveBeenCalledWith(
        `https://aso-int-ar.work-02.platform.bbva.com/documents-verifications/v3/validations/${veridasId}?flowId=00018`,
        config
      );
    });
  });

  describe("Get Renaper Validation Result ASO", () => {
    it("debería realizar un GET exitoso para obtener los resultados de Renaper", async () => {
      const config = { headers: { tsec: "mocked-tsec" } };
      const verificationId = "mocked-verification-id";

      const mockedResponse = {
        data: { result: "success", message: { validation: true } }
      };
      axios.get.mockResolvedValue(mockedResponse);

      const response = await ASO.getRenaperValidation(verificationId, config);

      expect(axios.get).toHaveBeenCalledWith(
        `https://aso-int-ar.work-02.platform.bbva.com/documents-verifications-api-local/v0/validations/${verificationId}`,
        config
      );

      expect(response).toEqual(mockedResponse);
    });

    it("debería manejar errores al realizar el GET", async () => {
      const config = { headers: { tsec: "mocked-tsec" } };
      const verificationId = "mocked-verification-id";

      const mockedError = new Error("Error en la solicitud");
      axios.get.mockRejectedValue(mockedError);

      await expect(
        ASO.getRenaperValidation(verificationId, config)
      ).rejects.toThrow("Error en la solicitud");

      // Verificar que Axios fue llamado con los parámetros correctos
      expect(axios.get).toHaveBeenCalledWith(
        `https://aso-int-ar.work-02.platform.bbva.com/documents-verifications-api-local/v0/validations/${verificationId}`,
        config
      );
    });
  });

  describe("getFlowIdByCamp", () => {
    it("debería retornar el flowId correcto para cada campaña conocida", () => {
      expect(getFlowIdByCamp("ofertaCajaAhorro")).toBe("00010");
      expect(getFlowIdByCamp("ofertaCGU")).toBe("00011");
      expect(getFlowIdByCamp("ofertaEmprendedores")).toBe("00014");
      expect(getFlowIdByCamp("ofertaNomina")).toBe("00018");
    });

    it("debería retornar '00010' para campañas desconocidas o undefined", () => {
      expect(getFlowIdByCamp("campaña-inexistente")).toBe("00010");
      expect(getFlowIdByCamp(undefined)).toBe("00010");
      expect(getFlowIdByCamp(null)).toBe("00010");
      expect(getFlowIdByCamp("")).toBe("00010");
    });
  });
});
